module.exports = __webpack_public_path__ + "static/covid-2-50bb8e761ac4d855f072357dba433fbb.png";